import { combineReducers } from "redux";
import { appReducer } from "./appReducers";
import { userInfoReducer } from "./userInfoReducers"
import { configReducer } from "./configReducers"

const rootReducer = combineReducers({
  app: appReducer,
  config: configReducer,
  userInfo: userInfoReducer
});

export default rootReducer;
